// extracted by mini-css-extract-plugin
export var labelWrapper = "_f8-0";